import { api } from "./api";

export interface SeoData {
  title: string;
  description: string;
  keywords: string;
  og_image: string;
  canonical?: string;
}

export interface CmsBlock {
  type: string;
  [key: string]: unknown;
}

export interface CmsPage {
  id: number;
  slug: string;
  title: string;
  subtitle?: string | null;
  hero_image?: string | null;
  sections: CmsBlock[];
  seo: SeoData;
  status: string;
  template: string;
  created_at?: string;
  updated_at?: string;
}

/** Public read — published page with SEO backfilled from content. */
export function getPage(slug: string): Promise<CmsPage> {
  return api.get<CmsPage>(`/pages/${encodeURIComponent(slug)}`);
}

/** Admin CMS pages CRUD + SEO generation. */
export const cmsApi = {
  list: () => api.get<CmsPage[]>("/cms/pages"),
  detail: (id: number) => api.get<CmsPage>(`/cms/pages/${id}`),
  create: (data: Partial<CmsPage>) => api.post<CmsPage>("/cms/pages", data),
  update: (id: number, data: Partial<CmsPage>) => api.put<CmsPage>(`/cms/pages/${id}`, data),
  remove: (id: number) => api.del(`/cms/pages/${id}`),
  generateSeo: (data: { slug?: string; title?: string; subtitle?: string; hero_image?: string; sections?: CmsBlock[] }) =>
    api.post<SeoData>("/cms/pages/seo/generate", data),
};